import { useEffect, useRef, useState } from "react";
import { ScrollView } from "react-native";

const CAROUSEL_INTERVAL_MS = 4000;

export const useAutoCarousel = (
  scrollRef: React.RefObject<ScrollView | null>,
  count: number,
  step = 268,
) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const timer = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    if (count < 2) return;

    timer.current = setInterval(() => {
      setActiveIndex((prev) => {
        const next = (prev + 1) % count;
        scrollRef.current?.scrollTo({
          x: next * step,
          animated: true,
        });
        return next;
      });
    }, CAROUSEL_INTERVAL_MS);

    return () => clearInterval(timer.current ?? undefined);
  }, [count, scrollRef, step]);

  return activeIndex;
};
